import React, { useEffect, useState } from "react";
import Loader from "./components/loader/Loader";
import Aos from "aos";
import "aos/dist/aos.css";
import Home from "./pages/home/Home";
import Menu from "./components/menu/Menu";
import Footer from "./components/footer/Footer";


import { Routes, Route, useLocation } from "react-router-dom";
// import Certificate from "./components/certificateGenrator/Certificate";
import CertificateVerification from "./pages/certificate/CertificateVerification";

const App = () => {
  const [showPage, setShowPage] = useState(false);

  useEffect(() => {
    Aos.init({ duration: 100 });

    setTimeout(() => {
      setIsLoading(false);
    }, 6500);

    setTimeout(() => {
      setShowPage(true);
    }, 5000);
  }, [showPage]);

  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();

  const isHome = location.pathname === "/";

  return (
    <div>
      {isLoading && <Loader></Loader>}
      {showPage && (
        <>
        
        <div
            style={{
              display: 'flex',             
              justifyContent: 'center',    
              alignItems: 'center',       
             marginTop:'40px'
            }}
          >
            <Menu /> 
          </div>
          <Routes>
            {isHome && (
              <>
                <Route path="/" element={<Home />}></Route>
              </>
            )}
            <Route path="/certificates" element={<CertificateVerification/>}></Route>
          </Routes>
          <Footer></Footer>
        </>
      )}
    </div>
  );
};

export default App;
